import { Box, Grow, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CelebrationIcon from "@mui/icons-material/Celebration";

const ProgresoSemanaBanner = ({ dias = [], diasElegidosFechas = [] }) => {
  const total = dias.length;
  const elegidos = dias.filter((d) => diasElegidosFechas.includes(d.fecha)).length;
  const completo = total > 0 && elegidos === total;

  if (!total) return null;

  return (
    <Box sx={{ position: "relative", minHeight: 56 }}>
      <Grow in={completo} unmountOnExit>
        <Box
          sx={{
            position: completo ? "static" : "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            px: 2.5,
            py: 1.5,
            borderRadius: 4,
            background: "linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)",
            boxShadow: "0 6px 20px rgba(46,125,50,0.35)",
            color: "#fff",
          }}
        >
          <CelebrationIcon sx={{ fontSize: 28 }} />
          <Box>
            <Typography sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              ¡Semana completa! 🎉
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.92 }}>
              Ya elegiste tus {total} viandas de la semana.
            </Typography>
          </Box>
        </Box>
      </Grow>

      <Grow in={!completo} unmountOnExit>
        <Box
          sx={{
            position: !completo ? "static" : "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            px: 2,
            py: 1.25,
            borderRadius: 4,
            bgcolor: "rgba(31,97,141,0.05)",
            border: "1px solid rgba(31,97,141,0.15)",
          }}
        >
          <Typography sx={{ fontWeight: 700, color: "#1F618D" }}>
            {elegidos}/{total} elegidas
          </Typography>

          <Box sx={{ display: "flex", gap: 0.75 }}>
            {dias.map((d) => {
              const elegido = diasElegidosFechas.includes(d.fecha);
              return (
                <Box
                  key={d.fecha}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 0.25,
                  }}
                >
                  {elegido ? (
                    <CheckCircleIcon sx={{ color: "#2E7D32", fontSize: 22 }} />
                  ) : (
                    <RadioButtonUncheckedIcon
                      sx={{ color: "rgba(0,0,0,0.25)", fontSize: 22 }}
                    />
                  )}
                  <Typography
                    variant="caption"
                    sx={{
                      color: elegido ? "#2E7D32" : "text.secondary",
                      fontWeight: elegido ? 700 : 500,
                    }}
                  >
                    {d.labelCorto}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Grow>
    </Box>
  );
};

export default ProgresoSemanaBanner;
